<fui-textarea-control [disabled]="isReadonly" [label]="label" [labelI18NParams]="i18nParams" [placeholder]="placeholder"
                      [(ngModel)]="value" [attr.id]="elementId" [control]="formControl" >
</fui-textarea-control>
